import ManageAttendance from './ManageAttendance';
import SubViewOptions from '../SubViewOptions';
import React from 'react';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param string - subView: sub-view type
 * @param event - changeSubViewManage: event to change the sub-view
 */
const Settings = (
    {
        subView,
        changeSubViewManage,
        registerAction
    }
) => {

    return (
        <>
            <div className="d-flex mb-3">
                <SubViewOptions
                    subView={subView}
                    changeSubViewManage={changeSubViewManage}
                />
            </div>
            <ManageAttendance
                registerAction={registerAction}
            />
        </>
    );
}

export default Settings
